import { globalGetService } from '../../../utils/globalApiServices';

export function getBrandStatistics() {
  return globalGetService(
    'csp/statistics/brand?excludeSoleProprietor=false'
  ).then((response) => (response?.ok ? response.data : null));
}
export function getCampaignStatistics() {
  return globalGetService('csp/statistics/campaign').then((response) =>
    response?.ok ? response.data : null
  );
}

export function getPartnerCampaignStatistics() {
  return globalGetService(`csp/campaigns/sharedWithMe`, {
    actionableOnly: true,
    status: 'ACTIVE',
  }).then((response) => {
    if (response?.ok) {
      return { total: response.data.totalRecords };
    }
  });
}

export function getCampaignTopUseCase() {
  return globalGetService('csp/statistics/campaign/topUseCase').then(
    (response) => (response?.ok ? response.data : null)
  );
}

export function getEventHistory(query = {}) {
  return globalGetService('csp/event', { ...query, recordsPerPage: 20 }).then(
    (response) => (response?.ok ? response.data : null)
  );
}

export async function getCampaignDetail(campaignUid) {
  const response = await globalGetService(`csp/campaigns/${campaignUid}`);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  return null;
}

export async function getCampaignByPhone(phoneNumber) {
  const response = await globalGetService(
    `csp/campaigns/byPhone/${phoneNumber}`
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  return null;
}
